import { type Dayjs, isDayjs } from 'dayjs'
import * as yup from 'yup'

declare module 'yup' {
  interface MixedSchema {
    /**
     * @description Validates that the value is a valid Dayjs object or null
     * @returns The schema
     */
    dayjs(message: string): yup.MixedSchema<Dayjs | null>
  }
}

yup.addMethod(yup.mixed, 'dayjs', function (message: string) {
  return yup.mixed().test('is-dayjs', message, (value) => {
    if (value === null || value === undefined) return true // Allow required to pick up validation
    return isDayjs(value) && value.isValid()
  })
})

export {}
